import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link } from "react-router-dom";
import { Card, Col, Nav, Button, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Grid } from "gridjs-react";

export default function PublisherInvoices() {

  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">

        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link href="#">PUB Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Invoices</li>
            </ol>
            <h4 className="main-title mb-0">Invoices</h4>
          </div>

          <Nav as="nav" className="nav-icon nav-icon-lg">
            <OverlayTrigger overlay={<Tooltip>Print</Tooltip>}>
              <Nav.Link href=""><i className="ri-printer-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Report</Tooltip>}>
              <Nav.Link href=""><i className="ri-bar-chart-2-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>New Invoice</Tooltip>}>
              <Nav.Link href=""><i className="ri-add-line"></i></Nav.Link>
            </OverlayTrigger>
          </Nav>

        </div>

        <Row className="g-3 justify-content-center">
  
          <Col md="12">
            <Card className="card-one">
              <Card.Body>
                <div className="table-responsive">
                  <Grid
                    data={[
                      ['1', 'ABC Bank', 'ABC Bank', '$35,000.00', 'PAID']
                    ]}
                    columns={['ID', 'Campaign', 'Account', 'Amount', 'Status']}
                    search={true}
                    pagination={{
                      enabled: true,
                      limit: 15
                    }}
                    sort={true}
                    className={{
                      table: 'table table-bordered table-hover mb-0'
                    }}
                  />
                </div>
                <Button href="/invoices/invoice" variant="primary">Preview Invoice</Button>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        <Footer />
      </div>
    </React.Fragment>
  )
}